'use strict';

var utilities = require('./utilityFunctions');

var puids = {};
puids.rnds = {}; // значение rnd пуида по типам рекламы

var ADV_DURATION_TYPE_PUIDS = puids.ADV_DURATION_TYPE_PUIDS = [{edge: 30, val: 0}, {edge: 60, val: 1}, {edge: 90, val: 2}, {edge: 120, val: 3}, {edge: 180, val: 4}, {edge: 240, val: 5}, {edge: 300, val: 6}, {edge: 600, val: 7}, {edge: 900, val: 8}, {edge: 1800, val: 9}, {edge: 3600, val: 10}, {edge: 5400, val: 11}, {edge: 7200, val: 12}, {edge: Infinity, val: 13}];
var ADV_DURATION_LIVE_PUID = puids.ADV_DURATION_LIVE_PUID = 14;
var ADV_SIZE_TYPE_PUIDS = puids.ADV_SIZE_TYPE_PUIDS = [{edge: 400, val: 5}, {edge: 640, val: 0}, {edge: 960, val: 1}, {edge: 1280, val: 2}, {edge: Infinity, val: 3}];


/**
 * Returns an object that replaces placeholders for puids in advert url.
 * Supported types: url, duration_type, player_size_type, fullscreen.
 * Config format:
 *  {
 *     placeholders: { 
 *       type1: {
 *         name: 'type1_alias', // or 'type1' if does not presented 
 *         rule: function() {
 *          // code to get value, that replaces type1 placeholder.
 *         }
 *       },
 *       type2: {
 *         ...
 *       },
 *     },
 *
 *     prefix: '$', // symbols before placeholder name
 *     postfix: '' // 
 *  }                 
 * @param {object} player The videojs player object
 * @param {object} config Settings for puid replacemant (see example above)
 */

puids.getProcessedUrl = function (player, url, config) {
  var config = config || {};
  if (!url) return url;

  for(var type in config.placeholders) { 
    if (!config.placeholders.hasOwnProperty(type)) continue;

    var name = puids.getPuidPlaceholderName(type, config),
        value;

    if (name) {
      value = puids.getPuidPlaceholderValue(player, type, config);
      if (typeof(value) !== undefined) {
        name = new RegExp(name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
        url = url.replace(name, value);
      }
    }

  }


  return url;
};

puids.getReplacements = function(player, config) {
  var config = config || {};
  var result = {};

  for (var type in config.placeholders) {
    if (!config.placeholders.hasOwnProperty(type)) continue;

    var name = puids.getPuidPlaceholderName(type, config);
    if (!name) continue;

    var value = puids.getPuidPlaceholderValue(player, type, config);
    if (typeof(value) !== undefined) {
      result[name] = value;
    }
  }

  return result;
}

puids.getPuidPlaceholderName = function(type, config) {
  var config = config || {},
      name = (config.placeholders[type] || {}).name || type,
      res = name ? config.prefix + name + config.postfix : '';
  return res;
};
 
puids.getPuidPlaceholderValue = function(player, type, config) {
  var config = config || {},
      placeholder = config.placeholders[type],
      rule = placeholder && placeholder.rule ? placeholder.rule : puids.getPuidDefaultRule(player, type);
      
  return utilities.isString(placeholder) ? placeholder : utilities.isFunction(rule) ? rule(player, config, puids) : undefined;
};

puids.getPuidDefaultRule = function(player, type) {
  switch (type) {
    case 'url':
      return function(){
        return encodeURIComponent(utilities.isIFrame() ? (player.options_.referrer || document.referrer) : document.location.href);
      };
    break;
    case 'duration_type':
      return function(){
        return player.options().is_live || player.duration() === Infinity ? ADV_DURATION_LIVE_PUID : puids.getAdvertPuidFromEdges(ADV_DURATION_TYPE_PUIDS, player.duration());
      };
      break;
    case 'player_size_type':
      return function(){
        return puids.getAdvertPuidFromEdges(ADV_SIZE_TYPE_PUIDS, (player.el() || {}).offsetWidth);
      };
    break;
    case 'fullscreen':
      return function(){
        return player.isFullscreen() || utilities.isIPhone() ? 0 : 1;
      };
    break;
    case 'rnd':
      return function(){
        var ad_type = player.vast && player.vast.curAd && player.vast.curAd.type;
        return puids.rnds[player.vast.curAd.type];
      };
    break;
    default:
    return null;
  }
};

puids.getAdvertPuidFromEdges = function(edges, val){
  var puid_val = 4, // 4 - size unknown
    len = edges.length;
  
  for (var i = 0; i < len; i++) {
    if (val < edges[i].edge) {
      puid_val = edges[i].val;
      break;
    }
  };
  return puid_val;
};

puids.generateRnd = function(ad_type){
  var rnd = Math.floor(Math.floor(Math.random() * (1000000000 - 100000000)) + 100000000);
  puids.rnds[ad_type] = rnd;
};

module.exports = puids;
